<template>
    <div class="fm-table">
        <table  class="table table-sm">
            <thead>
            <tr>
                <th class="w-65" v-on:click="sortBy('name')">
                    {{ lang.manager.table.name }}
                    <template v-if="sortSettings.field === 'name'">
                        <i class="fas fa-arrow-down"
                           v-show="sortSettings.direction === 'down'"></i>
                        <i class="fas fa-arrow-up"
                           v-show="sortSettings.direction === 'up'"></i>
                    </template>
                </th>
                <th class="w-10" v-on:click="sortBy('size')">
                    {{ lang.manager.table.size }}
                    <template v-if="sortSettings.field === 'size'">
                        <i class="fas fa-arrow-down"
                           v-show="sortSettings.direction === 'down'"></i>
                        <i class="fas fa-arrow-up"
                           v-show="sortSettings.direction === 'up'"></i>
                    </template>
                </th>
                <th class="w-10" v-on:click="sortBy('type')">
                    {{ lang.manager.table.type }}
                    <template v-if="sortSettings.field === 'type'">
                        <i class="fas fa-arrow-down"
                           v-show="sortSettings.direction === 'down'"></i>
                        <i class="fas fa-arrow-up"
                           v-show="sortSettings.direction === 'up'"></i>
                    </template>
                </th>
                <th class="w-auto" v-on:click="sortBy('date')">
                    {{ lang.manager.table.date }}
                    <template v-if="sortSettings.field === 'date'">
                        <i class="fas fa-arrow-down"
                           v-show="sortSettings.direction === 'down'"></i>
                        <i class="fas fa-arrow-up"
                           v-show="sortSettings.direction === 'up'"></i>
                    </template>
                </th>
                <th class="w-auto"><span v-if="!isListing">Actions</span></th>
            </tr>
            </thead>
            <tbody>
            <v-hover v-slot:default="{ hover }" v-if="!isRootPath">
                <tr v-if="!isRootPath"  v-bind:class="{'elevation-4': hover}">
                    <td colspan="5" class="fm-content-item" v-on:click="levelUp">
                         <span class="fa-stack bg-fa-level-up-alt">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="fas fa-stack-1x fa-level-up-alt"></i>
                        </span> Previous Folder
                    </td>
                </tr>
            </v-hover>

            <v-hover v-slot:default="{ hover }" v-for="(directory, index) in listings" v-bind:key="`l-${index}`">
                <tr
                        v-bind:key="`d-${index}`"
                        v-bind:class="{'table-info': checkSelect('directories', directory.path), 'elevation-4': hover}"
                        v-on:click="selectItem('directories', directory.path, $event)"
                >
                    <td class="fm-content-item unselectable"
                        v-bind:class="(acl && directory.acl === 0) ? 'text-hidden' : ''"
                        v-on:click="selectDirectory(directory.path)">
                    <span class="fa-stack bg-fa-list">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-stack-1x fa-inverse fa-list"></i>
                    </span>
                        {{ directory.basename }}
                    </td>
                    <td></td>
                    <td>List</td>
                    <td>
                        <!--{{ timestampToDate(directory.timestamp) }}-->
                    </td>
                    <td class="fm-content-item-actions">
                      <button type="button" class="btn btn-secondary mr-3">
                          <i class="fas fa-link"
                            v-on:click="copyFolderLink(directory)"
                            v-bind:title="lang.btn.link || 'Copy Link'"></i>
                        </button>
                        <button type="button" class="btn btn-secondary invisible">
                          <i class="fas fa-trash-alt" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
            </v-hover>

            <v-hover v-slot:default="{ hover }" v-for="(directory, index) in directories" v-bind:key="`d-${index}`">
                <tr
                        v-bind:key="`d-${index}`"
                        v-bind:class="{'table-info': checkSelect('directories', directory.path), 'elevation-4': hover}"
                        v-on:click="selectItem('directories', directory.path, $event)"
                >
                    <td class="fm-content-item unselectable"
                        v-bind:class="(acl && directory.acl === 0) ? 'text-hidden' : ''"
                        v-on:click="selectDirectory(directory.path)">
                    <span class="fa-stack bg-fa-folder">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-stack-1x fa-inverse fa-folder"></i>
                    </span>
                        {{ directory.basename }}
                    </td>
                    <td></td>
                    <td>{{ lang.manager.table.folder }}</td>
                    <td>
                        {{ timestampToDate(directory.timestamp) }}
                    </td>
                    <td class="fm-content-item-actions">
                        <button type="button" class="btn btn-secondary mr-3">
                          <i class="fas fa-link"
                            v-on:click="copyFolderLink(directory)"
                            v-bind:title="lang.btn.link || 'Copy Link'"></i>
                        </button>
                        <button type="button" class="btn btn-secondary"
                                v-if="!directory.locked"
                                v-on:click="deleteFolder(directory)"
                                v-bind:title="lang.btn.delete">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>
            </v-hover>

            <v-hover v-slot:default="{ hover }" v-for="(file, index) in files" v-bind:key="`f-${index}`">
                <tr
                        v-bind:key="`f-${index}`"
                        v-bind:class="{'table-info': checkSelect('files', file.path), 'elevation-4': hover}"
                >
                    <td class="fm-content-item unselectable"
                        v-on:click="download(file, $event);"
                        v-bind:class="(acl && file.acl === 0) ? 'text-hidden' : ''">
                    <span class="fa-stack" v-bind:class="'bg-'+extensionToIcon(file.extension)">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-stack-1x fa-inverse" v-bind:class="extensionToIcon(file.extension)"></i>
                    </span>
                        {{ file.basename }}
                    </td>
                    <td class="fm-content-item-filesize">{{ bytesToHuman(file.size) }}</td>
                    <td class="fm-content-item-filetype">
                        {{ file.extension }}
                    </td>
                    <td class="fm-content-item-filetype">
                        {{ timestampToDate(file.timestamp) }}
                    </td>
                    <td class="fm-content-item-actions">
                        <button type="button" class="btn btn-secondary mr-3">
                          <i class="fas fa-link"
                            v-on:click="copyFileLink(file)"
                            v-bind:title="lang.btn.link || 'Copy Link'"></i>
                        </button>
                        <button type="button" class="btn btn-secondary"
                                v-if="!file.locked"
                                v-on:click="deleteFile(file)"
                                v-bind:title="lang.btn.delete">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>
            </v-hover>
            </tbody>
        </table>
    </div>
</template>

<script>
import translate from './../../mixins/translate';
import helper from './../../mixins/helper';
import managerHelper from './mixins/manager';
import contextMenuActions from '../blocks/mixins/contextMenuActions';
import HTTP from '../../http/get';

export default {
  name: 'table-view',
  // mixins: [translate, contextMenu, contextMenuRules, contextMenuActions],
  mixins: [translate, helper, managerHelper, contextMenuActions],
  props: {
    manager: { type: String, required: true },
  },
  computed: {
    hasContent() {
      return (this.files && this.files.length > 0) || (this.directories && this.directories.length > 0);
    },
    /**
             * Sort settings
             * @returns {*}
             */
    sortSettings() {
      return this.$store.state.fm[this.manager].sort;
    },
  },
  methods: {
    deleteFolder(folder) {
      const items = [{
        path: folder.path,
        type: folder.type,
      }];
      if (confirm('Are you sure you want to delete this folder?')) {
        // create items list for delete
        this.$store.dispatch('fm/delete', items).then(() => {
          // Delete successful.
        });
      }
    },
    deleteFile(file) {
      const items = [{
        path: file.path,
        type: file.type,
      }];
      if (confirm('Are you sure you want to delete this file?')) {
        // create items list for delete
        this.$store.dispatch('fm/delete', items).then(() => {
          // Delete successful.
        });
      }
    },
    getName(item) {
      return item.basename;
    },
    getPath(path) {
      const split = path.split('/');
      if (split[0] === 'file_manager') {
        return path.split('/').slice(3).join('/');
      }

      // TODO: 20240909: I would love to have this passed in as a prop or otherwise
      // set someplace else and then pulled in (i.e. via store?).
      return 'Group Wall Files';
    },
    copyFileLink(file) {
      const name = this.getName(file);
      const path = this.getPath(file.dirname);
      const url = `${window.location.origin + window.location.pathname}?folder=${path}&file=${name}`;

      // Now I need to copy the path to the user's clipboard.
      navigator.clipboard.writeText(url).then(() => {
        this.$store.commit('updateMessage', {
          message: `Copied ${url} to clipboard`,
          snackbar: true,
        });
        console.log(`Copied ${url} to clipboard`);
      });
    },
    copyFolderLink(folder) {
      let { path } = folder;

      // The path uses / as the separator.
      // I need to remove the first 3 segments to get the right path.
      path = this.getPath(path); // .split('/').slice(3).join('/');
      const url = `${window.location.origin + window.location.pathname}?folder=${path}`;

      // Now I need to copy the path to the user's clipboard.
      navigator.clipboard.writeText(url).then(() => {
        this.$store.commit('updateMessage', {
          message: `Copied ${url} to clipboard`,
          snackbar: true,
        });
        console.log(`Copied ${url} to clipboard`);
      });
    },
    download(file, $event) {
      this.selectItem('files', file.path, $event);
      this.downloadFile(file);
    },
    /**
     * Copy-pasta from amaze-vue-laravel-file-manager/src/components/blocks/mixins/contextMenuActions.js.
     * Made minor changes to better support available data structures and context.
     */
    downloadFile(file) {
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.setAttribute('download', file.basename);

      // download file with authorization
      if (this.$store.getters['fm/settings/authHeader']) {
        HTTP.download(this.selectedDisk, file.path).then((response) => {
          tempLink.href = window.URL.createObjectURL(new Blob([response.data]));
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
        });
      } else {
        tempLink.href = `${this.$store.getters['fm/settings/baseUrl']}download?disk=${this.selectedDisk}&path=${encodeURIComponent(file.path)}`;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }
    },
    /**
             * Show modal window
             * @param modalName
             */
    showModal(modalName) {
      // show selected modal
      this.$store.commit('fm/modal/setModalState', {
        modalName,
        show: true,
      });
    },
    /**
             * Sort by field
             * @param field
             */
    sortBy(field) {
      this.$store.dispatch(`fm/${this.manager}/sortBy`, { field, direction: null });
    },
  },
};
</script>

<style lang="scss">
    .fm-table {

    .invisible {
      visibility: hidden;
    }

    thead th{
        background: white;
        position: sticky;
        top: 0;
        z-index: 10;
        cursor: pointer;
        border-top: none;

    &:hover {
         background-color: #f8f9fa;
     }

    & > i {
            padding-left: 0.5rem;
        }
    }

    td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // For the last td of each row of the table,
        // let's have the text align to the left.
        &.fm-content-item-actions {
            padding-left: 1rem !important;
        }
    }

    tr:hover {
        background-color: #f8f9fa;
    }

    .w-10 {
        width: 10%;
    }

    .w-65 {
        width: 65%;
    }

    .fm-content-item {
        cursor: pointer;
        max-width: 1px;
    }

    .text-hidden {
        color: #cdcdcd;
    }
    }
</style>
